import { oddsText } from "@/lib/prefs";
import { AlertTriangle, Check, Trash2 } from "lucide-react";
import { evText, lineText } from "./valueFormat";

export function CheckOdds({ items, onConfirm, onDelete }) {
  if (!items?.length) return null;
  return (
    <div className="vs-check" data-testid="value-check">
      <div className="vs-check-head"><AlertTriangle size={14} /> Check odds ({items.length}) · held back from value picks, Kelly and History until confirmed</div>
      {items.map((p) => (
        <div key={p.id} className="vs-check-row" data-testid={`value-check-${p.id}`}>
          <b>{p.player_name}</b>
          <span>{lineText(p)} @ {oddsText(p.odds)}{p.bookmaker ? ` · ${p.bookmaker}` : ""}{p.label ? ` · read "${p.label}"` : ""}</span>
          <span className="vs-check-why">{p.check}</span>
          <span>{evText(p.ev)}</span>
          <button type="button" onClick={() => onConfirm(p.id)} title="Odds are correct" data-testid={`value-check-confirm-${p.id}`}><Check size={14} /> Correct</button>
          <button type="button" onClick={() => onDelete(p.id)} title="Remove" data-testid={`value-check-delete-${p.id}`}><Trash2 size={14} /></button>
        </div>
      ))}
    </div>
  );
}
